import { render, staticRenderFns } from "./OriginalSharesEditPanel.vue?vue&type=template&id=3ce5d8b6"
import script from "./OriginalSharesEditPanel.vue?vue&type=script&lang=js"
export * from "./OriginalSharesEditPanel.vue?vue&type=script&lang=js"
import style0 from "./OriginalSharesEditPanel.vue?vue&type=style&index=0&id=3ce5d8b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports